// controller-paths-ignored-preflight.ts
//
// Code review G3 H1: every controller ticket must be committable. commit-owner
// silently skips an ignored pathspec, and since security audit H-1 (c) the
// owned-checkout reset deletes ignored files under `.avatar/tickets` — so in a
// repo that ignores `.avatar/`, `*.json` or `PLAN.md`, the first dispatch
// would erase every ticket. `run` refuses such a repo before anything runs.
// Outside a git repo (`check-ignore` exit 128) there is nothing to judge here.
// Review G3 M1: `-v` also prints (exit 0) a path a `!` rule keeps — so the
// verdict comes from the plain call, and `-v` only names the rule.
import { spawnAsyncCapture } from "../spawn-async-capture-with-timeout.js";

/** Probe paths: any ticket file name, and the PLAN index. */
const PROBES = [".avatar/tickets/T-0000-probe.json", ".avatar/PLAN.md"] as const;

/** `controller_path_ignored: …` naming the rule (`<source>:<line>:<pattern>`), or undefined. */
export async function findIgnoredControllerPathProblem(
  repoDir: string,
): Promise<string | undefined> {
  const checkIgnore = (flags: string[]) =>
    spawnAsyncCapture("git", ["check-ignore", ...flags, "--no-index", "--", ...PROBES], {
      cwd: repoDir,
      timeoutMs: 30_000,
      forwardSigint: false,
    });
  if ((await checkIgnore([])).status !== 0) return undefined;
  const res = await checkIgnore(["-v"]);
  const first = res.stdout.split("\n").find((line) => line.includes("\t")) ?? res.stdout.trim();
  const [rule = "", path = ""] = first.split("\t");
  return (
    `controller_path_ignored: ${path} bị git ignore bởi luật ${rule} — ticket và PLAN.md của ` +
    "Autopilot phải commit được (file bị ignore sẽ bị dọn khi reset worktree). Bỏ luật đó rồi chạy lại."
  );
}
